import React, { useState, useEffect } from "react";
import { Global } from "../helpers/Global";
import { Peticion } from "../helpers/Peticion";

export const About = () => {
  const [clients, setClients] = useState([]);
  const [review, setReview] = useState([]);
  const [skills, setSkills] = useState([]);

  const conseguirabout = async () => {
    let { datos } = await Peticion(Global.url + "about/clients/", "GET");

    if (datos) {
      setClients(datos.data);
    }
  };

  const conseguirhabilidades = async () => {
    let { datos } = await Peticion(Global.url + "about/skills/", "GET");

    if (datos) {
      setSkills(datos.data);
    }
  };

  const conseguirresenas = async () => {
    let { datos } = await Peticion(Global.url + "about/reviews/", "GET");

    if (datos) {
      setReview(datos.data);
    }
  };

  useEffect(() => {
    conseguirabout();
    conseguirresenas();
    conseguirhabilidades();
  }, []);

  return (
    <section className="content__page content__about">
      {/* <!-- contenido de about me --> */}
      <header className="about__header">
        <h1 className="about__title">
          Sobre <span className="title__color">Mi</span>
        </h1>
      </header>
      <section className="about__personal-info">
        <article className="personal-info__bio">
          <p className="personal-info__description">
            Hola, soy Gerlin Gonzalez, Analista de Sistemas y Especialista en Ciberseguridad (SOC). Me apasiona la administración de servidores, el despliegue de infraestructuras en la nube (VPS) y la protección de activos digitales. Mi enfoque se centra en garantizar la alta disponibilidad de los sistemas, monitorear vulnerabilidades en tiempo real y asegurar redes corporativas. Constantemente construyendo en mi entorno de laboratorio (Homelab) y preparándome para la certificación CompTIA Security+."
          </p>
        </article>
        <div className="personal-info__data">
          <ul className="personal-info__list">
            <li className="personal-info__option">
              <span className="personal-info__title">Edad</span>
              <span className="personal-info__value">37</span>
            </li>
            <li className="personal-info__option">
              <span className="personal-info__title">Pais</span>
              <span className="personal-info__value">Colombia</span>
            </li>
            {/* <li className="personal-info__option">
              <span className="personal-info__title">Direccion</span>
              <span className="personal-info__value">Tacarigua</span>
            </li> */}
            <li className="personal-info__option">
              <span className="personal-info__title">Correo</span>
              <span className="personal-info__value">gerlin@gegova.com.co</span>
            </li>
            <li className="personal-info__option">
              <span className="personal-info__title">Telefono</span>
              <span className="personal-info__value">+57 301 149 3468</span>
            </li>
          </ul>
        </div>
      </section>
      <section className="about__services">
        <header className="services__header">
          <h2 className="services__title">
            Lo que <span className="title__color">hago</span>
          </h2>
        </header>
        <div className="services__container">
           {skills.map((skill) => {
            return ( 
               <article key={skill.id} className="services__service">
                <div className="service__icon">
                  <i className={skill.icon + " service__real-icon "}></i> 
                </div>
                <div className="service__content">
                  <h3 className="service__title"> {skill.title} </h3>
                  <p className="service__description">
                    <div
                      dangerouslySetInnerHTML={{ __html: skill.description }}
                    ></div>
                  </p>
                </div>
              </article> 
             );
          })} 
        </div>
      </section>
      {/* <section className="about__reviews">
        <header className="reviews__header">
          <h2 className="reviews__title">Reseñas</h2>
        </header>


        <div className="reviews__container">
{review.map ((review) => {
            return (
          <article className="reviews__review" key={review.id}>
            <div className="review__image-container">
              <img
                src={ Global.media + review.photo }
                className="review__image"
                alt={ review.name }
              />
            </div>
            <div className="review__description">
              <p className="review__text"> {review.messege} </p>
            </div>
            <div className="review__author">
              <div className="review__author-info">
                <h4 className="review__name"> {review.name} </h4>
                <h5 className="review__company"> {review.subject}</h5>
              </div>
              <div className="review__author-icon">
                <i className="review__icon fa-solid fa-quote-right"></i>
              </div>
            </div>
          </article>
);
          })} 
        </div>


      </section> */}
      <section className="about__client">
        <header className="client__header">
          <h2 className="client__title">Clientes</h2>
        </header>

        <div className="client__container">
          {clients.map((client) => {
            return (
          <article className="client__item" key={client.id}>
            <a
              href={ client.link }
              className="client__link"
              target="_blank"
            >
              <img
                src= { Global.media + client.image}
                alt={ client.title }
                className="client__image"
              />
              {client.title}
            </a>
          </article>
          );
          })} 
        </div>
      </section>
    </section>
  );
};
